export default "__VITE_ASSET__DMBILIuF__"